import React from "react";
import Box from "@material-ui/core/Box";
import { useTranslate } from "react-polyglot";
import { makeStyles, Typography } from "@material-ui/core";
import DeckCard from "./DeckCard.jsx";
import { useCourseProvider } from "../../../Providers/Data/CourseProvider.jsx";
import DeckDataProvider from "../../../Providers/Data/DeckDataProvider.jsx";

const useStyles = makeStyles((theme) => ({
  deckListRoot: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    margin: "12px auto 30px auto",
    width: "calc(100% + 12px)",
    transform: "translateX(-6px)",
    [theme.breakpoints.up("lg")]: {
      width: "unset",
      transform: "none",
    },
  },
  decksName: {
    color: "#1B1C1C",
    fontSize: 18,
    fontWeight: 500,
    lineHeight: 1.25,
  },
}));

/** @returns {null|*}
 * @constructor
 */
const DeckList = () => {
  const classes = useStyles();
  const t = useTranslate();
  const { currentBranch } = useCourseProvider();

  if (!currentBranch) {
    return null;
  }

  return (
    <>
      <Typography className={classes.decksName}>{`${t("lessons")}:`}</Typography>
      <Box className={classes.deckListRoot}>
        {currentBranch.decks.map((deck) => (
          <DeckDataProvider key={deck.id} deck={deck} branch={currentBranch}>
            <DeckCard />
          </DeckDataProvider>
        ))}
      </Box>
    </>
  );
};

export default DeckList;
